<template>
  <v-card>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-layout column wrap xs6>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.scheme}}</v-subheader>
              <div class="title">{{this.$store.state.parameters.scheme.schemeMenu.sideMenuTitle}}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.riskNo}}</v-subheader>
              <div class="title">{{this.$store.state.parameters.scheme.stdRiskTxtMenu.title}}</div>
            </v-flex>
            <v-flex xs6>
              <v-subheader class="queryLabel">{{labels.stdRiskTxt}}</v-subheader>
              <div class="title">{{this.$store.state.parameters.scheme.stdRiskTxtMenu.stdRiskTxt}}</div>
            </v-flex>
            <v-flex xs6 v-if="!newStdItemTxt">
              <v-subheader class="queryLabel">{{labels.itemNo}}</v-subheader>
              <div class="title">{{this.stdRiskItemTxtForm.itemNo}}</div>
            </v-flex>
            <v-flex xs6 v-else>
              <v-autocomplete :label="labels.itemNo" v-model="stdRiskItemTxtForm.itemNo" :items="itemList" :error-messages="errors.first('scheme') ? errors.first('scheme') : errors.collect('itemNo')" data-vv-name="itemNo" :data-vv-as="labels.itemNo" v-validate="'required'" :loading="itemLoading"></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete :label="labels.stdItemTxt" v-model="stdRiskItemTxtForm.stdItemTxt" :items="stdItemTxt" item-text="value" item-value="value" :error-messages="errors.collect('stdItemTxt')" data-vv-name="stdItemTxt" :data-vv-as="labels.stdItemTxt" v-validate="'required'" :loading="textLoading" @input="doQueryText"></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-flex xs6>
            <v-textarea box rows="10" outline :label="labels.previewTxt" v-model="previewText" readonly no-resize></v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-flex xs12>
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
        {{ newStdItemTxt ? 'Save Risk Text' : 'Update Risk Text' }}
        <v-icon right>{{newStdItemTxt ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
    </v-flex>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      labels: {
        scheme: 'Scheme',
        riskNo: 'Risk No*',
        stdItemTxt: 'Standard Item Text*',
        previewTxt: 'Preview Text',
        itemNo: 'Item No*',
        stdRiskTxt: 'Standard Risk Text'
      },
      stdRiskItemTxtForm: {
        scheme: null,
        riskNo: null,
        itemNo: null,
        stdRiskTxt: null,
        stdItemTxt: null
      },
      newStdItemTxt: false,
      itemList: [],
      stdItemTxt: [],
      itemLoading: false,
      textLoading: false,
      previewText: '',
      submitting: false
    }
  },
  computed: {
    stdRiskTxtMenu() {
      return this.$store.state.parameters.scheme.stdRiskTxtMenu
    }
  },
  watch: {
    'ids.itemNo': function (value) {
      this.resetMessages()
      this.resetValidator()
      this.doClearForm()
      this.stdRiskItemTxtForm.scheme = this.ids.scheme
      this.stdRiskItemTxtForm.riskNo = this.ids.riskNo
      this.stdRiskItemTxtForm.stdRiskTxt = this.stdRiskTxtMenu.stdRiskTxt
      Promise.all([this.doItemList(), this.doStdItemTxtList(this.stdRiskItemTxtForm.stdRiskTxt)])
      if (value !== 'new') {
        this.newStdItemTxt = false
        if (value !== null) {
          this.fetchData(value)
        }
      } else {
        this.newStdItemTxt = true
      }
    }
  },
  methods: {
    async fetchData(itemNo) {
      const apiURI = this.stdRiskTxtMenu.menu.pkgStdItemTxt
      if (apiURI) {
        const expand = {
          scheme: this.ids.scheme,
          riskNo: this.ids.riskNo,
          itemNo: this.ids.itemNo
        }
        try {
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.stdRiskItemTxtForm.scheme = data.pkgStdItemTxt.scheme
            this.stdRiskItemTxtForm.riskNo = data.pkgStdItemTxt.riskNo
            this.stdRiskItemTxtForm.itemNo = data.pkgStdItemTxt.itemNo
            this.stdRiskItemTxtForm.stdRiskTxt = data.pkgStdItemTxt.stdRiskTxt
            this.stdRiskItemTxtForm.stdItemTxt = data.pkgStdItemTxt.stdItemTxt
            this.previewText = data.pkgStdItemTxt.stdItemTxtDesc
            this.menu = extractMenu(result.data._links)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Standard Risk Text Review')
      }
    },
    async doItemList() {
      const apiURI = this.stdRiskTxtMenu.menu.itemList
      if (apiURI) {
        try {
          const expand = {
            scheme: this.ids.scheme,
            riskNo: this.ids.riskNo
          }
          this.itemLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.itemList = data.itemList
          }
          this.itemLoading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL - Risk List')
      }
    },
    async doStdItemTxtList(stdRiskTxt) {
      const apiURI = this.stdRiskTxtMenu.menu.stdItemList
      if (apiURI) {
        const expand = {
          stdRiskTxt: stdRiskTxt
        }
        try {
          this.textLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.stdItemTxt = data.stdItemTxtList
          }
          this.textLoading = false
        } catch (err) {
          throw err
        }
      } else {
        this.errorMessage('Invalid API URL - Text List')
      }
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.stdRiskItemTxtForm.scheme = this.ids.scheme
      this.stdRiskItemTxtForm.riskNo = null
      this.stdRiskItemTxtForm.itemNo = null
      this.stdRiskItemTxtForm.stdItemTxt = null
      this.previewText = ''
    },
    async doQueryText(value) {
      const tempText = this.stdItemTxt.find(item => item.value === value)
      this.previewText = tempText.label
    },
    async doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newStdItemTxt) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.stdRiskTxtMenu.menu.pkgStdItemTxtCreate
      if (apiURI) {
        try {
          const result = await this.$http.post(apiURI, this.stdRiskItemTxtForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('resetTab', 2)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.pkgStdItemTxtUpdate
      if (apiURI) {
        try {
          const formatForm = {
            scheme: this.stdRiskItemTxtForm.scheme,
            riskNo: this.stdRiskItemTxtForm.riskNo,
            itemNo: this.stdRiskItemTxtForm.itemNo,
            stdRiskTxt: this.stdRiskItemTxtForm.stdRiskTxt,
            stdItemTxt: this.stdRiskItemTxtForm.stdItemTxt
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.fetchData(this.ids.riskNo)
            this.doItemList()
            this.doStdItemTxtList(this.stdRiskItemTxtForm.stdRiskTxt)
            this.doQueryText(this.stdRiskItemTxtForm.stdItemTxt)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  props: {
    ids: {
      type: Object,
      default () {
        return {
          scheme: null,
          riskNo: null,
          itemNo: null,
          stdRiskTxt: null
        }
      }
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
